// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%28255,255,255,1%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://cdn.jsdelivr.net/npm/bootstrap-icons@1.11.3/font/bootstrap-icons.min.css);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
  border: 0;
}

body {
  background-color: #f5f5f5;
  font-family: 'Roboto', sans-serif;
}

h1, h2, h3, h4, h5, h6 {
  font-family: 'Roboto Slab', serif;
  font-weight: 700;
}

.navbar {
  background-color: #db1010;
}
.navbar-brand, .nav-link {
  color: white !important;
}

.navbar-toggler {
  border-color: white;
}
.navbar-toggler-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.btn-primary {
  background-color: #db1010;
  border-color: #db1010;
  color: white;
}
.btn-primary:hover {
  background-color: #600000;
  border-color: #600000;
  color: white;
}

.btn-outline-primary {
  color: #db1010;
  border-color: #db1010;
}
.btn-outline-primary:hover {
  background-color: #db1010;
  border-color: #db1010;
  color: white;
}

footer {
  background-color: #db1010;
  color: white;
}

.login-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #db1010 0%, #600000 100%);
}

.login-card {
  background: white;
  padding: 2rem;
  border-radius: 15px;
  box-shadow: 0 10px 30px rgba(0,0,0,0.3);
  width: 100%;
  max-width: 400px;
}

.login-card img {
  max-width: 200px;
  margin-bottom: 1.5rem;
}

.foro-container {
  padding-top: 80px;
  min-height: calc(100vh - 60px);
}

.comentario-card {
  background: white;
  border-radius: 10px;
  padding: 1.5rem;
  margin-bottom: 1.5rem;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
  transition: transform 0.2s;
}

.comentario-card:hover {
  transform: translateY(-2px);
}

.comentario-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.5rem;
}

.comentario-usuario {
  font-weight: 700;
  color: #db1010;
}

.comentario-fecha {
  color: #666;
  font-size: 0.9rem;
}

.comentario-contenido {
  margin: 0.5rem 0;
  line-height: 1.6;
}

.comentario-actions {
  display: flex;
  gap: 1rem;
  margin-top: 0.5rem;
  align-items: center;
}

.respuesta-container {
  margin-left: 2rem;
  margin-top: 1rem;
  padding-left: 1rem;
  border-left: 3px solid #db1010;
}

.respuesta-card {
  background: #f8f9fa;
  border-radius: 8px;
  padding: 1rem;
  margin-bottom: 0.8rem;
}

@media (max-width: 768px) {
  .respuesta-container {
    margin-left: 0.5rem;
    padding-left: 0.5rem;
  }
}

/* Estilos para Material de Estudio */
.hover-shadow {
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.hover-shadow:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 20px rgba(0,0,0,0.15) !important;
}

.card-title {
  font-family: 'Roboto Slab', serif;
  font-weight: 700;
}

/* Iconos de Bootstrap */

/*================================================*/

/* Sub Navbar */
.sub-navbar {
  background-color: #1a1a2e;
  padding: 6px 0;
  margin-top: 56px; /* Altura del navbar principal */
  border-bottom: 2px solid #db1010;
}

.sub-navbar-nav {
  display: flex;
  justify-content: center;
  list-style: none;
  margin: 0;
  padding: 0;
  gap: 30px;
}

.sub-navbar-nav a {
  color: #ffffff;
  text-decoration: none;
  font-size: 0.85rem;
  font-weight: 500;
  transition: color 0.3s ease;
  display: flex;
  align-items: center;
}

.sub-navbar-nav a:hover {
  color: #ffd700;
}

@media (max-width: 576px) {
  .sub-navbar-nav {
    gap: 15px;
    font-size: 0.75rem;
  }
}

/* Estilos del comentario plegable */
.comentario-texto {
  line-height: 1.6;
  white-space: pre-wrap;
  word-wrap: break-word;
  transition: all 0.3s ease;
}

.comentario-texto.plegado {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  mask-image: linear-gradient(to bottom, #000 60%, transparent 100%);
  -webkit-mask-image: linear-gradient(to bottom, #000 60%, transparent 100%);
}

/* Botón "Ver más" / "Ver menos" */
.btn-ver-mas {
  background: none;
  border: none;
  color: #db1010;
  font-size: 0.85rem;
  font-weight: 600;
  padding: 4px 0;
  margin-top: 4px;
  cursor: pointer;
  transition: color 0.3s ease;
  display: flex;
  align-items: center;
}

.btn-ver-mas:hover {
  color: #600000;
  text-decoration: underline;
}

.btn-ver-mas i {
  font-size: 0.75rem;
}

/***************************************************************/

/* Contenido de la respuesta */
.respuesta-contenido {
  margin-top: 4px;
}

.respuesta-contenido .comentario-texto {
  line-height: 1.5;
  font-size: 0.95rem;
  white-space: pre-wrap;
  word-wrap: break-word;
}

/* Ajustar el plegado para respuestas (2 líneas en lugar de 4) */
.respuesta-contenido .comentario-texto.plegado {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  mask-image: linear-gradient(to bottom, #000 60%, transparent 100%);
  -webkit-mask-image: linear-gradient(to bottom, #000 60%, transparent 100%);
}

/* Botón "Ver más" en respuestas (más pequeño) */
.respuesta-contenido .btn-ver-mas {
  font-size: 0.75rem;
  padding: 2px 0;
  margin-top: 2px;
}

.respuesta-contenido .btn-ver-mas i {
  font-size: 0.65rem;
}

/* ============================================
   DROPDOWN DE USUARIO - ESCRITORIO
   ============================================ */

@media (min-width: 992px) {
  .user-dropdown {
    background-color: #ffffff;
    border: 2px solid #db1010;
    border-radius: 10px;
    box-shadow: 0 8px 24px rgba(0,0,0,0.2);
    min-width: 240px;
    padding: 8px 0;
    margin-top: 8px;
  }

  .user-dropdown .dropdown-header {
    color: #db1010;
    font-weight: 700;
    font-size: 0.75rem;
    text-transform: uppercase;
    letter-spacing: 1px;
    padding: 10px 18px 6px;
    border-bottom: 1px solid #e9ecef;
    margin-bottom: 4px;
  }

  .user-dropdown .dropdown-item {
    color: #333;
    font-size: 0.9rem;
    font-weight: 500;
    padding: 10px 18px;
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .user-dropdown .dropdown-item:hover {
    background-color: #f8f9fa;
    color: #db1010;
  }

  .user-dropdown .dropdown-item.active {
    background-color: #db1010;
    color: white;
  }

  .user-dropdown .dropdown-item i {
    width: 20px;
    text-align: center;
  }

  .user-dropdown .dropdown-item-text {
    padding: 10px 18px;
    font-size: 0.9rem;
    color: #6c757d;
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .user-dropdown .dropdown-item.text-danger {
    color: #dc3545;
    font-weight: 600;
  }

  .user-dropdown .dropdown-item.text-danger:hover {
    background-color: #dc3545;
    color: white;
  }

  .user-dropdown .dropdown-divider {
    margin: 6px 0;
    border-color: #e9ecef;
  }
}

/* ============================================
   DROPDOWN DE USUARIO - MÓVIL Y TABLET
   ============================================ */

@media (max-width: 991.98px) {
  .user-dropdown {
    position: static !important;
    background-color: rgba(0, 0, 0, 0.3) !important;
    border: none !important;
    border-radius: 8px !important;
    box-shadow: none !important;
    margin-top: 8px !important;
    padding: 0 !important;
    width: 100% !important;
  }

  .user-dropdown .dropdown-header {
    color: #ffffff !important;
    background-color: rgba(0, 0, 0, 0.2) !important;
    font-weight: 700 !important;
    font-size: 0.75rem !important;
    text-transform: uppercase !important;
    letter-spacing: 1px !important;
    padding: 10px 16px !important;
    margin: 0 !important;
    border: none !important;
    border-bottom: 1px solid rgba(255, 255, 255, 0.15) !important;
  }

  .user-dropdown .dropdown-item {
    color: #ffffff !important;
    background-color: transparent !important;
    font-size: 0.95rem !important;
    font-weight: 500 !important;
    padding: 12px 16px !important;
    border: none !important;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1) !important;
    border-radius: 0 !important;
    display: flex !important;
    align-items: center !important;
    gap: 10px !important;
    width: 100% !important;
    text-align: left !important;
  }

  .user-dropdown .dropdown-item:last-child {
    border-bottom: none !important;
  }

  .user-dropdown .dropdown-item:hover,
  .user-dropdown .dropdown-item:focus {
    background-color: rgba(255, 255, 255, 0.15) !important;
    color: #ffffff !important;
  }

  .user-dropdown .dropdown-item.active {
    background-color: rgba(255, 255, 255, 0.2) !important;
    color: #ffffff !important;
    border-left: 4px solid #ffd700 !important;
    padding-left: 12px !important;
  }

  .user-dropdown .dropdown-item i {
    color: #ffffff !important;
    width: 20px !important;
    text-align: center !important;
    font-size: 1rem !important;
  }

  .user-dropdown .dropdown-item-text {
    color: #ffffff !important;
    background-color: transparent !important;
    padding: 12px 16px !important;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1) !important;
    display: flex !important;
    align-items: center !important;
    gap: 10px !important;
    font-size: 0.95rem !important;
  }

  .user-dropdown .dropdown-item-text i {
    color: #ffffff !important;
    width: 20px !important;
    text-align: center !important;
  }

  .user-dropdown .dropdown-item.text-danger {
    color: #ffcccc !important;
    font-weight: 600 !important;
    border-bottom: none !important;
  }

  .user-dropdown .dropdown-item.text-danger:hover {
    background-color: rgba(220, 53, 69, 0.5) !important;
    color: #ffffff !important;
  }

  .user-dropdown .dropdown-divider {
    margin: 0 !important;
    border-color: rgba(255, 255, 255, 0.15) !important;
  }

  /* Botón del dropdown en móvil */
  .navbar .dropdown-toggle {
    color: #ffffff !important;
    background-color: transparent !important;
    border: none !important;
    width: 100% !important;
    text-align: left !important;
    padding: 10px 0 !important;
    font-size: 1rem !important;
  }

  .navbar .dropdown-toggle:hover,
  .navbar .dropdown-toggle:focus {
    color: #ffd700 !important;
  }

  .navbar .dropdown-toggle::after {
    float: right;
    margin-top: 8px;
    color: #ffffff !important;
  }
}

/* ============================================
   RESPONSIVE - PANTALLAS MUY PEQUEÑAS
   ============================================ */

@media (max-width: 575.98px) {
  .user-dropdown .dropdown-item {
    padding: 10px 14px !important;
    font-size: 0.9rem !important;
  }

  .user-dropdown .dropdown-header {
    font-size: 0.7rem !important;
    padding: 8px 14px !important;
  }

  .user-dropdown .dropdown-item-text {
    padding: 10px 14px !important;
    font-size: 0.9rem !important;
  }
}

/* ============================================
   CRONOGRAMA - ESTADÍSTICAS
   ============================================ */

.stat-card {
  background: white;
  border-radius: 12px;
  padding: 16px;
  text-align: center;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
  border-left: 4px solid #db1010;
  transition: transform 0.2s ease;
}

.stat-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 6px 16px rgba(0,0,0,0.12);
}

.stat-card.stat-total { border-left-color: #db1010; }
.stat-card.stat-presencial { border-left-color: #28a745; }
.stat-card.stat-virtual { border-left-color: #17a2b8; }

.stat-number {
  font-size: 2rem;
  font-weight: 700;
  color: #333;
  line-height: 1;
}

.stat-label {
  font-size: 0.8rem;
  color: #6c757d;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-top: 4px;
}

/* ============================================
   CALENDARIO COMPACTO
   ============================================ */

.calendar-grid {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 2px;
  max-width: 100%;
}

.calendar-header-cell {
  text-align: center;
  font-weight: 700;
  font-size: 0.65rem;   /* ← más pequeño */
  color: #6c757d;
  text-transform: uppercase;
  padding: 4px 2px;
  background-color: #f8f9fa;
  border-radius: 4px;
  letter-spacing: 0.3px;
}

.calendar-cell {
  aspect-ratio: 1;
  background: white;
  border: 1px solid #e9ecef;
  border-radius: 4px;
  padding: 2px 3px;
  display: flex;
  flex-direction: column;
  position: relative;
  transition: all 0.15s ease;
  min-height: 32px;   /* ← antes 60px */
  max-height: 40px;
  overflow: hidden;
}

.calendar-cell.empty {
  background: transparent;
  border: none;
}

.calendar-cell.has-event {
  background: linear-gradient(135deg, #fff5f5 0%, #ffe5e5 100%);
  border-color: #db1010;
  cursor: pointer;
}

.calendar-cell.has-event:hover {
  transform: scale(1.08);
  box-shadow: 0 2px 8px rgba(219, 16, 16, 0.25);
  z-index: 10;
}

.calendar-day {
  font-weight: 700;
  font-size: 0.7rem;   /* ← antes 0.9rem */
  color: #333;
  line-height: 1;
}

.calendar-events {
  display: flex;
  flex-wrap: wrap;
  gap: 2px;
  margin-top: 2px;
}

.calendar-event-dot {
  width: 5px;    /* ← antes 8px */
  height: 5px;
  border-radius: 50%;
}

.dot-presencial {
  background-color: #db1010;   /* ← Rojo intenso */
}

.dot-virtual {
  background-color: #0d47a1;   /* ← Azul profundo */
}

/* Badges de tipo */
.badge.bg-success {
  background-color: #db1010 !important;  /* Presencial = rojo */
}

.badge.bg-info {
  background-color: #0d47a1 !important;  /* Virtual = azul */
}

.calendar-more {
  font-size: 0.55rem;
  color: #db1010;
  font-weight: 700;
}

.legend-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
}

/* ============================================
   TARJETAS DE SESIÓN
   ============================================ */

.sesion-card {
  background: white;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
  transition: all 0.3s ease;
  border-left: 4px solid #db1010;
  height: 100%;
}

.sesion-card.card-presencial {
  border-left-color: #db1010;
}

.sesion-card.card-virtual {
  border-left-color: #0d47a1;
}

.sesion-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 20px rgba(0,0,0,0.12);
}

.sesion-card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  background-color: #f8f9fa;
  border-bottom: 1px solid #e9ecef;
}

.sesion-card-fecha {
  font-weight: 700;
  color: #333;
  font-size: 0.9rem;
}

.sesion-card-body {
  padding: 16px;
}

.sesion-modulo {
  color: #db1010;
  font-weight: 700;
}

.sesion-num {
  color: #6c757d;
  font-size: 0.9rem;
}

.sesion-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-size: 0.85rem;
  color: #6c757d;
  margin-top: 8px;
}

/* ============================================
   VISTA LINEAL (TIMELINE)
   ============================================ */

.modulo-group {
  background: white;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
}

.modulo-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 12px;
  margin-bottom: 16px;
  border-bottom: 2px solid #db1010;
  color: #db1010;
}

.modulo-timeline {
  position: relative;
  padding-left: 24px;
}

.modulo-timeline::before {
  content: '';
  position: absolute;
  left: 8px;
  top: 0;
  bottom: 0;
  width: 2px;
  background: linear-gradient(to bottom, #db1010 0%, #e9ecef 100%);
}

.timeline-item {
  position: relative;
  margin-bottom: 20px;
  padding-left: 24px;
}

.timeline-item:last-child {
  margin-bottom: 0;
}

.timeline-dot {
  position: absolute;
  left: -20px;
  top: 6px;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  border: 3px solid white;
  box-shadow: 0 0 0 2px #e9ecef;
}

/* Timeline dots */
.timeline-dot.dot-presencial {
  background-color: #db1010;
  box-shadow: 0 0 0 2px #db1010;
}

.timeline-dot.dot-virtual {
  background-color: #0d47a1;
  box-shadow: 0 0 0 2px #0d47a1;
}

.timeline-content {
  background: #f8f9fa;
  border-radius: 8px;
  padding: 12px 16px;
  transition: all 0.2s ease;
}

.timeline-content:hover {
  background: #e9ecef;
  transform: translateX(4px);
}

.timeline-sesion {
  color: #db1010;
  font-size: 1rem;
}

.timeline-details {
  font-size: 0.85rem;
  color: #6c757d;
  margin-top: 4px;
}

/* ============================================
   MODAL DE SESIÓN
   ============================================ */

.modal-backdrop-custom {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0,0,0,0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  padding: 20px;
  animation: fadeIn 0.2s ease;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

.modal-card {
  background: white;
  border-radius: 12px;
  max-width: 380px;
  width: 100%;
  box-shadow: 0 20px 60px rgba(0,0,0,0.3);
  animation: slideUp 0.3s ease;
  overflow: hidden;
}

@keyframes slideUp {
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
}

.modal-card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  background-color: #db1010;
  color: white;
}

.btn-close-custom {
  background: none;
  border: none;
  color: white;
  font-size: 1.2rem;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 6px;
  transition: background 0.2s;
}

.btn-close-custom:hover {
  background-color: rgba(255,255,255,0.2);
}

.modal-card-body {
  padding: 16px;
}

.sesion-detalle {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 16px;
  font-size: 0.95rem;
}

/* ============================================
   RESPONSIVE - CALENDARIO
   ============================================ */

/* Escritorio grande: Calendario más ancho pero aún compacto */
@media (min-width: 992px) {
  .calendar-grid {
    gap: 3px;
  }

  .calendar-cell {
    min-height: 38px;
    max-height: 46px;
  }

  .calendar-day {
    font-size: 0.75rem;
  }
}

/* Tablet: Ajustar proporciones */
@media (max-width: 991.98px) and (min-width: 577px) {
  .calendar-grid {
    gap: 2px;
  }

  .calendar-cell {
    min-height: 34px;
    max-height: 42px;
    padding: 2px;
  }

  .calendar-day {
    font-size: 0.7rem;
  }
}

/* Móvil: Compacto */
@media (max-width: 576px) {
  .calendar-grid {
    gap: 2px;
  }

  .calendar-cell {
    min-height: 30px;
    max-height: 36px;
    padding: 2px;
    border-radius: 3px;
  }

  .calendar-day {
    font-size: 0.65rem;
  }

  .calendar-header-cell {
    font-size: 0.55rem;
    padding: 3px 1px;
  }

  .calendar-event-dot {
    width: 4px;
    height: 4px;
  }

  .calendar-more {
    font-size: 0.5rem;
  }

  .modal-card {
    max-width: 95%;
  }

  .modal-card-header,
  .modal-card-body {
    padding: 12px;
  }
}

/* Móvil muy pequeño */
@media (max-width: 400px) {
  .calendar-cell {
    min-height: 26px;
    max-height: 32px;
    padding: 1px;
  }

  .calendar-day {
    font-size: 0.6rem;
  }

  .calendar-header-cell {
    font-size: 0.5rem;
  }
}

/* ============================================
   BANNER CON CARRUSEL - SIN ESPACIO SUPERIOR
   ============================================ */

.banner-foro {
  width: 100%;
  margin: 0;
  padding: 0;
  background-color: #db1010;
  margin-top: 0;        /* ← SIN margen superior */
  overflow: hidden;
  line-height: 0;
  display: block;
}

.banner-carousel {
  position: relative;
  width: 100%;
  overflow: hidden;
  display: block;
  line-height: 0;
}

.banner-slide {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: auto;
  max-height: 380px;
  object-fit: cover;
  opacity: 0;
  transition: opacity 1.5s ease-in-out;
  display: block;
}

.banner-slide.active {
  opacity: 1;
  position: relative;   /* ← Define la altura según la imagen */
}

/* Responsive */
@media (max-width: 768px) {
  .banner-slide {
    max-height: 150px;
  }
}

@media (max-width: 576px) {
  .banner-slide {
    max-height: 100px;
  }
}

/* ============================================
   RETROALIMENTACIONES
   ============================================ */

.retroalimentacion-section {
  border-top: 1px solid #e9ecef;
  padding-top: 12px;
  margin-top: 12px;
}

.retroalimentacion-card {
  background: #f8f9fa;
  border-left: 3px solid #db1010;
  border-radius: 8px;
  padding: 12px 16px;
  margin-bottom: 10px;
}

.retroalimentacion-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 6px;
}

.retroalimentacion-usuario {
  color: #db1010;
  font-size: 0.9rem;
}

.retroalimentacion-contenido {
  margin: 6px 0;
  font-size: 0.9rem;
  line-height: 1.5;
}

.retroalimentacion-contenido .comentario-texto.plegado {
  max-height: 6em;   /* 4 líneas × 1.5em line-height */
  overflow: hidden;
  position: relative;
}

.retroalimentacion-contenido .comentario-texto.plegado::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 2em;
  background: linear-gradient(to bottom, transparent, #f8f9fa);
  pointer-events: none;
}

.retroalimentacion-archivo {
  border-top: 1px dashed #dee2e6;
  padding-top: 8px;
  margin-top: 8px;
}

/* ============================================
   MODAL GENÉRICO (usado por ambos modales)
   ============================================ */

.modal-backdrop-custom {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 99999;
  padding: 20px;
  animation: fadeIn 0.2s ease;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

.modal-card {
  background: white;
  border-radius: 12px;
  max-width: 450px;
  width: 100%;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.4);
  animation: slideUp 0.3s ease;
  position: relative;
  z-index: 100000;
}

@keyframes slideUp {
  from { 
    opacity: 0; 
    transform: translateY(20px); 
  }
  to { 
    opacity: 1; 
    transform: translateY(0); 
  }
}

.modal-card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  background-color: #db1010;
  color: white;
  border-radius: 12px 12px 0 0;
}

.modal-card-header h5 {
  color: white;
  margin: 0;
  font-weight: 600;
}

.btn-close-custom {
  background: none;
  border: none;
  color: white;
  font-size: 1.1rem;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 6px;
  transition: background 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
}

.btn-close-custom:hover {
  background-color: rgba(255, 255, 255, 0.2);
}

.modal-card-body {
  padding: 24px;
}

/* ============================================
   CAMPOS DE FORMULARIO DENTRO DEL MODAL
   ============================================ */

.modal-card-body .form-label {
  color: #333;
  font-weight: 600;
  font-size: 0.85rem;
  margin-bottom: 6px;
}

.modal-card-body .form-control {
  border-radius: 8px;
  border: 1px solid #dee2e6;
  padding: 10px 14px;
  transition: border-color 0.2s, box-shadow 0.2s;
  font-size: 0.95rem;
}

.modal-card-body .form-control:focus {
  border-color: #db1010;
  box-shadow: 0 0 0 0.2rem rgba(219, 16, 16, 0.15);
  outline: none;
}

/* ============================================
   ENLACE "¿OLVIDASTE TU CONTRASEÑA?" EN LOGIN
   ============================================ */

.login-card .btn-link {
  color: #6c757d !important;
  text-decoration: underline !important;
  font-size: 0.85rem;
  border: none;
  background: none;
  cursor: pointer;
  padding: 0;
}

.login-card .btn-link:hover {
  color: #db1010 !important;
}

/* ============================================
   INPUT DE CONTRASEÑA CON OJO
   ============================================ */

.password-input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.password-input-wrapper .password-input {
  padding-right: 45px;  /* Espacio para el ícono */
}

.password-toggle {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  color: #6c757d;
  font-size: 1.1rem;
  padding: 6px 10px;
  cursor: pointer;
  border-radius: 6px;
  transition: color 0.2s, background-color 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
}

.password-toggle:hover {
  color: #db1010;
  background-color: rgba(219, 16, 16, 0.08);
}

.password-toggle:focus {
  outline: none;
  color: #db1010;
}

.password-toggle i {
  pointer-events: none;  /* El ícono no interfiere con el clic */
}

/* linkify*/

.comentario-texto a {
  color: #db1010;
  text-decoration: underline;
  word-break: break-word;
}

.comentario-texto a:hover {
  color: #600000;
  text-decoration: none;
}

/* ============================================
   PRÓXIMA SESIÓN - PANEL DESTACADO
   ============================================ */

.proxima-sesion-panel {
  margin-top: 0;
}

.proxima-sesion-card {
  position: relative;
  background: linear-gradient(135deg, #db1010 0%, #600000 100%);
  border-radius: 20px;
  padding: 2rem;
  color: white;
  box-shadow: 0 12px 40px rgba(219, 16, 16, 0.4);
  overflow: hidden;
  animation: proximaPulse 3s ease-in-out infinite;
}

@keyframes proximaPulse {
  0%, 100% { box-shadow: 0 12px 40px rgba(219, 16, 16, 0.4); }
  50% { box-shadow: 0 12px 60px rgba(219, 16, 16, 0.7); }
}

.proxima-sesion-card::before {
  content: '';
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: linear-gradient(
    45deg,
    transparent 30%,
    rgba(255, 255, 255, 0.1) 50%,
    transparent 70%
  );
  animation: shine 4s ease-in-out infinite;
}

@keyframes shine {
  0% { transform: translateX(-100%) translateY(-100%) rotate(45deg); }
  100% { transform: translateX(100%) translateY(100%) rotate(45deg); }
}

.proxima-sesion-badge {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  background: rgba(255, 255, 255, 0.2);
  color: white;
  padding: 0.4rem 1rem;
  border-radius: 20px;
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  margin-bottom: 1.5rem;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.3);
  position: relative;
  z-index: 1;
}

.proxima-sesion-badge i {
  animation: blink 1.5s ease-in-out infinite;
}

@keyframes blink {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.4; }
}

.proxima-sesion-content {
  display: flex;
  align-items: flex-start;
  gap: 1.5rem;
  position: relative;
  z-index: 1;
}

.proxima-sesion-icon {
  flex-shrink: 0;
  width: 70px;
  height: 70px;
  background: rgba(255, 255, 255, 0.15);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 2rem;
  backdrop-filter: blur(10px);
  border: 2px solid rgba(255, 255, 255, 0.3);
}

.proxima-sesion-info {
  flex-grow: 1;
}

.proxima-sesion-title {
  font-family: 'Roboto Slab', serif;
  font-weight: 700;
  font-size: 1.6rem;
  margin-bottom: 0.5rem;
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}

.proxima-sesion-desc {
  font-size: 1rem;
  opacity: 0.95;
  margin-bottom: 1.25rem;
  line-height: 1.5;
}

.proxima-sesion-btn {
  background: white;
  color: #db1010;
  font-weight: 700;
  padding: 0.75rem 1.75rem;
  border-radius: 12px;
  border: none;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
}

.proxima-sesion-btn:hover {
  background: white;
  color: #600000;
  transform: translateY(-2px) scale(1.02);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.3);
}

.proxima-sesion-empty {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border: 2px dashed #adb5bd;
  border-radius: 20px;
  padding: 2.5rem;
  text-align: center;
  color: #6c757d;
}

.proxima-sesion-empty i {
  font-size: 3rem;
  color: #adb5bd;
  margin-bottom: 1rem;
  display: block;
  animation: hourglass 3s ease-in-out infinite;
}

@keyframes hourglass {
  0%, 100% { transform: rotate(0deg); }
  50% { transform: rotate(180deg); }
}

.proxima-sesion-empty p {
  font-size: 1.1rem;
  font-weight: 500;
}

@media (max-width: 768px) {
  .proxima-sesion-card { padding: 1.5rem; }
  .proxima-sesion-content { flex-direction: column; align-items: center; text-align: center; }
  .proxima-sesion-icon { width: 60px; height: 60px; font-size: 1.6rem; }
  .proxima-sesion-title { font-size: 1.3rem; }
  .proxima-sesion-btn { width: 100%; }
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;EACV,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,yDAAyP;AAC3P;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6DAA6D;AAC/D;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uCAAuC;EACvC,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,qBAAqB;EACrB,sCAAsC;EACtC,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE;IACE,mBAAmB;IACnB,oBAAoB;EACtB;AACF;;AAEA,qCAAqC;AACrC;EACE,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;EAC3B,mDAAmD;AACrD;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA,wBAAwB;;AAGxB,mDAAmD;;AAEnD,eAAe;AACf;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB,EAAE,gCAAgC;EAClD,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,SAAS;AACX;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,SAAS;IACT,kBAAkB;EACpB;AACF;;AAEA,oCAAoC;AACpC;EACE,gBAAgB;EAChB,qBAAqB;EACrB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,4BAA4B;EAC5B,gBAAgB;EAChB,kEAAkE;EAClE,0EAA0E;AAC5E;;AAEA,kCAAkC;AAClC;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,eAAe;EACf,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;AACpB;;AAEA,gEAAgE;;AAEhE,8BAA8B;AAC9B;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA,gEAAgE;AAChE;EACE,oBAAoB;EACpB,4BAA4B;EAC5B,gBAAgB;EAChB,kEAAkE;EAClE,0EAA0E;AAC5E;;AAEA,gDAAgD;AAChD;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;iDAEiD;;AAEjD;EACE;IACE,yBAAyB;IACzB,yBAAyB;IACzB,mBAAmB;IACnB,sCAAsC;IACtC,gBAAgB;IAChB,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;IACnB,sBAAsB;IACtB,gCAAgC;IAChC,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,QAAQ;EACV;;EAEA;IACE,yBAAyB;IACzB,cAAc;EAChB;;EAEA;IACE,yBAAyB;IACzB,YAAY;EACd;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,QAAQ;EACV;;EAEA;IACE,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;IACzB,YAAY;EACd;;EAEA;IACE,aAAa;IACb,qBAAqB;EACvB;AACF;;AAEA;;iDAEiD;;AAEjD;EACE;IACE,2BAA2B;IAC3B,+CAA+C;IAC/C,uBAAuB;IACvB,6BAA6B;IAC7B,2BAA2B;IAC3B,0BAA0B;IAC1B,qBAAqB;IACrB,sBAAsB;EACxB;;EAEA;IACE,yBAAyB;IACzB,+CAA+C;IAC/C,2BAA2B;IAC3B,6BAA6B;IAC7B,oCAAoC;IACpC,8BAA8B;IAC9B,6BAA6B;IAC7B,oBAAoB;IACpB,uBAAuB;IACvB,6DAA6D;EAC/D;;EAEA;IACE,yBAAyB;IACzB,wCAAwC;IACxC,6BAA6B;IAC7B,2BAA2B;IAC3B,6BAA6B;IAC7B,uBAAuB;IACvB,4DAA4D;IAC5D,2BAA2B;IAC3B,wBAAwB;IACxB,8BAA8B;IAC9B,oBAAoB;IACpB,sBAAsB;IACtB,2BAA2B;EAC7B;;EAEA;IACE,8BAA8B;EAChC;;EAEA;;IAEE,sDAAsD;IACtD,yBAAyB;EAC3B;;EAEA;IACE,qDAAqD;IACrD,yBAAyB;IACzB,yCAAyC;IACzC,6BAA6B;EAC/B;;EAEA;IACE,yBAAyB;IACzB,sBAAsB;IACtB,6BAA6B;IAC7B,0BAA0B;EAC5B;;EAEA;IACE,yBAAyB;IACzB,wCAAwC;IACxC,6BAA6B;IAC7B,4DAA4D;IAC5D,wBAAwB;IACxB,8BAA8B;IAC9B,oBAAoB;IACpB,6BAA6B;EAC/B;;EAEA;IACE,yBAAyB;IACzB,sBAAsB;IACtB,6BAA6B;EAC/B;;EAEA;IACE,yBAAyB;IACzB,2BAA2B;IAC3B,8BAA8B;EAChC;;EAEA;IACE,mDAAmD;IACnD,yBAAyB;EAC3B;;EAEA;IACE,oBAAoB;IACpB,kDAAkD;EACpD;;EAEA,gCAAgC;EAChC;IACE,yBAAyB;IACzB,wCAAwC;IACxC,uBAAuB;IACvB,sBAAsB;IACtB,2BAA2B;IAC3B,0BAA0B;IAC1B,0BAA0B;EAC5B;;EAEA;;IAEE,yBAAyB;EAC3B;;EAEA;IACE,YAAY;IACZ,eAAe;IACf,yBAAyB;EAC3B;AACF;;AAEA;;iDAEiD;;AAEjD;EACE;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;;EAEA;IACE,4BAA4B;IAC5B,4BAA4B;EAC9B;;EAEA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;AACF;;AAEA;;iDAEiD;;AAEjD;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,sCAAsC;EACtC,8BAA8B;EAC9B,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;EAC3B,uCAAuC;AACzC;;AAEA,wBAAwB,0BAA0B,EAAE;AACpD,6BAA6B,0BAA0B,EAAE;AACzD,0BAA0B,0BAA0B,EAAE;;AAEtD;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;;iDAEiD;;AAEjD;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB,IAAI,kBAAkB;EACxC,cAAc;EACd,yBAAyB;EACzB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,0BAA0B;EAC1B,gBAAgB,IAAI,iBAAiB;EACrC,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,6DAA6D;EAC7D,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,6CAA6C;EAC7C,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,iBAAiB,IAAI,mBAAmB;EACxC,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,UAAU,KAAK,gBAAgB;EAC/B,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,yBAAyB,IAAI,mBAAmB;AAClD;;AAEA;EACE,yBAAyB,IAAI,oBAAoB;AACnD;;AAEA,mBAAmB;AACnB;EACE,oCAAoC,GAAG,sBAAsB;AAC/D;;AAEA;EACE,oCAAoC,GAAG,mBAAmB;AAC5D;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;;iDAEiD;;AAEjD;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,sCAAsC;EACtC,yBAAyB;EACzB,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;EAC3B,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;;iDAEiD;;AAEjD;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,MAAM;EACN,SAAS;EACT,UAAU;EACV,gEAAgE;AAClE;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA,kBAAkB;AAClB;EACE,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;;iDAEiD;;AAEjD;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,iCAAiC;EACjC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,uCAAuC;EACvC,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;iDAEiD;;AAEjD,8DAA8D;AAC9D;EACE;IACE,QAAQ;EACV;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA,iCAAiC;AACjC;EACE;IACE,QAAQ;EACV;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA,oBAAoB;AACpB;EACE;IACE,QAAQ;EACV;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,UAAU;IACV,WAAW;EACb;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,cAAc;EAChB;;EAEA;;IAEE,aAAa;EACf;AACF;;AAEA,sBAAsB;AACtB;EACE;IACE,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;;iDAEiD;;AAEjD;EACE,WAAW;EACX,SAAS;EACT,UAAU;EACV,yBAAyB;EACzB,aAAa,SAAS,0BAA0B;EAChD,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,UAAU;EACV,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,kBAAkB,IAAI,uCAAuC;AAC/D;;AAEA,eAAe;AACf;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;;iDAEiD;;AAEjD;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe,IAAI,iCAAiC;EACpD,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,WAAW;EACX,4DAA4D;EAC5D,oBAAoB;AACtB;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;iDAEiD;;AAEjD;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,0CAA0C;EAC1C,4BAA4B;EAC5B,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,aAAa;AACf;;AAEA;;iDAEiD;;AAEjD;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,8CAA8C;EAC9C,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,gDAAgD;EAChD,aAAa;AACf;;AAEA;;iDAEiD;;AAEjD;EACE,yBAAyB;EACzB,qCAAqC;EACrC,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;iDAEiD;;AAEjD;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB,GAAG,0BAA0B;AAClD;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,6CAA6C;EAC7C,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,oBAAoB,GAAG,uCAAuC;AAChE;;AAEA,WAAW;;AAEX;EACE,cAAc;EACd,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;;iDAEiD;;AAEjD;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,6DAA6D;EAC7D,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,8CAA8C;EAC9C,gBAAgB;EAChB,+CAA+C;AACjD;;AAEA;EACE,WAAW,8CAA8C,EAAE;EAC3D,MAAM,8CAA8C,EAAE;AACxD;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ;;;;;GAKC;EACD,wCAAwC;AAC1C;;AAEA;EACE,KAAK,4DAA4D,EAAE;EACnE,OAAO,0DAA0D,EAAE;AACrE;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,oCAAoC;EACpC,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,qBAAqB;EACrB,2BAA2B;EAC3B,0CAA0C;EAC1C,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,WAAW,UAAU,EAAE;EACvB,MAAM,YAAY,EAAE;AACtB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,wBAAwB;EACxB,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,uCAAuC;EACvC,yCAAyC;AAC3C;;AAEA;EACE,6DAA6D;EAC7D,0BAA0B;EAC1B,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,cAAc;EACd,4CAA4C;AAC9C;;AAEA;EACE,WAAW,uBAAuB,EAAE;EACpC,MAAM,yBAAyB,EAAE;AACnC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB,eAAe,EAAE;EACxC,0BAA0B,sBAAsB,EAAE,mBAAmB,EAAE,kBAAkB,EAAE;EAC3F,uBAAuB,WAAW,EAAE,YAAY,EAAE,iBAAiB,EAAE;EACrE,wBAAwB,iBAAiB,EAAE;EAC3C,sBAAsB,WAAW,EAAE;AACrC","sourcesContent":["* {\r\n  margin: 0;\r\n  padding: 0;\r\n  border: 0;\r\n}\r\n\r\nbody {\r\n  background-color: #f5f5f5;\r\n  font-family: 'Roboto', sans-serif;\r\n}\r\n\r\nh1, h2, h3, h4, h5, h6 {\r\n  font-family: 'Roboto Slab', serif;\r\n  font-weight: 700;\r\n}\r\n\r\n.navbar {\r\n  background-color: #db1010;\r\n}\r\n.navbar-brand, .nav-link {\r\n  color: white !important;\r\n}\r\n\r\n.navbar-toggler {\r\n  border-color: white;\r\n}\r\n.navbar-toggler-icon {\r\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3e%3cpath stroke='rgba(255,255,255,1)' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e\");\r\n}\r\n\r\n.btn-primary {\r\n  background-color: #db1010;\r\n  border-color: #db1010;\r\n  color: white;\r\n}\r\n.btn-primary:hover {\r\n  background-color: #600000;\r\n  border-color: #600000;\r\n  color: white;\r\n}\r\n\r\n.btn-outline-primary {\r\n  color: #db1010;\r\n  border-color: #db1010;\r\n}\r\n.btn-outline-primary:hover {\r\n  background-color: #db1010;\r\n  border-color: #db1010;\r\n  color: white;\r\n}\r\n\r\nfooter {\r\n  background-color: #db1010;\r\n  color: white;\r\n}\r\n\r\n.login-container {\r\n  min-height: 100vh;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  background: linear-gradient(135deg, #db1010 0%, #600000 100%);\r\n}\r\n\r\n.login-card {\r\n  background: white;\r\n  padding: 2rem;\r\n  border-radius: 15px;\r\n  box-shadow: 0 10px 30px rgba(0,0,0,0.3);\r\n  width: 100%;\r\n  max-width: 400px;\r\n}\r\n\r\n.login-card img {\r\n  max-width: 200px;\r\n  margin-bottom: 1.5rem;\r\n}\r\n\r\n.foro-container {\r\n  padding-top: 80px;\r\n  min-height: calc(100vh - 60px);\r\n}\r\n\r\n.comentario-card {\r\n  background: white;\r\n  border-radius: 10px;\r\n  padding: 1.5rem;\r\n  margin-bottom: 1.5rem;\r\n  box-shadow: 0 2px 10px rgba(0,0,0,0.1);\r\n  transition: transform 0.2s;\r\n}\r\n\r\n.comentario-card:hover {\r\n  transform: translateY(-2px);\r\n}\r\n\r\n.comentario-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin-bottom: 0.5rem;\r\n}\r\n\r\n.comentario-usuario {\r\n  font-weight: 700;\r\n  color: #db1010;\r\n}\r\n\r\n.comentario-fecha {\r\n  color: #666;\r\n  font-size: 0.9rem;\r\n}\r\n\r\n.comentario-contenido {\r\n  margin: 0.5rem 0;\r\n  line-height: 1.6;\r\n}\r\n\r\n.comentario-actions {\r\n  display: flex;\r\n  gap: 1rem;\r\n  margin-top: 0.5rem;\r\n  align-items: center;\r\n}\r\n\r\n.respuesta-container {\r\n  margin-left: 2rem;\r\n  margin-top: 1rem;\r\n  padding-left: 1rem;\r\n  border-left: 3px solid #db1010;\r\n}\r\n\r\n.respuesta-card {\r\n  background: #f8f9fa;\r\n  border-radius: 8px;\r\n  padding: 1rem;\r\n  margin-bottom: 0.8rem;\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .respuesta-container {\r\n    margin-left: 0.5rem;\r\n    padding-left: 0.5rem;\r\n  }\r\n}\r\n\r\n/* Estilos para Material de Estudio */\r\n.hover-shadow {\r\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\r\n}\r\n\r\n.hover-shadow:hover {\r\n  transform: translateY(-5px);\r\n  box-shadow: 0 10px 20px rgba(0,0,0,0.15) !important;\r\n}\r\n\r\n.card-title {\r\n  font-family: 'Roboto Slab', serif;\r\n  font-weight: 700;\r\n}\r\n\r\n/* Iconos de Bootstrap */\r\n@import url(\"https://cdn.jsdelivr.net/npm/bootstrap-icons@1.11.3/font/bootstrap-icons.min.css\");\r\n\r\n/*================================================*/\r\n\r\n/* Sub Navbar */\r\n.sub-navbar {\r\n  background-color: #1a1a2e;\r\n  padding: 6px 0;\r\n  margin-top: 56px; /* Altura del navbar principal */\r\n  border-bottom: 2px solid #db1010;\r\n}\r\n\r\n.sub-navbar-nav {\r\n  display: flex;\r\n  justify-content: center;\r\n  list-style: none;\r\n  margin: 0;\r\n  padding: 0;\r\n  gap: 30px;\r\n}\r\n\r\n.sub-navbar-nav a {\r\n  color: #ffffff;\r\n  text-decoration: none;\r\n  font-size: 0.85rem;\r\n  font-weight: 500;\r\n  transition: color 0.3s ease;\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.sub-navbar-nav a:hover {\r\n  color: #ffd700;\r\n}\r\n\r\n@media (max-width: 576px) {\r\n  .sub-navbar-nav {\r\n    gap: 15px;\r\n    font-size: 0.75rem;\r\n  }\r\n}\r\n\r\n/* Estilos del comentario plegable */\r\n.comentario-texto {\r\n  line-height: 1.6;\r\n  white-space: pre-wrap;\r\n  word-wrap: break-word;\r\n  transition: all 0.3s ease;\r\n}\r\n\r\n.comentario-texto.plegado {\r\n  display: -webkit-box;\r\n  -webkit-box-orient: vertical;\r\n  overflow: hidden;\r\n  mask-image: linear-gradient(to bottom, #000 60%, transparent 100%);\r\n  -webkit-mask-image: linear-gradient(to bottom, #000 60%, transparent 100%);\r\n}\r\n\r\n/* Botón \"Ver más\" / \"Ver menos\" */\r\n.btn-ver-mas {\r\n  background: none;\r\n  border: none;\r\n  color: #db1010;\r\n  font-size: 0.85rem;\r\n  font-weight: 600;\r\n  padding: 4px 0;\r\n  margin-top: 4px;\r\n  cursor: pointer;\r\n  transition: color 0.3s ease;\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.btn-ver-mas:hover {\r\n  color: #600000;\r\n  text-decoration: underline;\r\n}\r\n\r\n.btn-ver-mas i {\r\n  font-size: 0.75rem;\r\n}\r\n\r\n/***************************************************************/\r\n\r\n/* Contenido de la respuesta */\r\n.respuesta-contenido {\r\n  margin-top: 4px;\r\n}\r\n\r\n.respuesta-contenido .comentario-texto {\r\n  line-height: 1.5;\r\n  font-size: 0.95rem;\r\n  white-space: pre-wrap;\r\n  word-wrap: break-word;\r\n}\r\n\r\n/* Ajustar el plegado para respuestas (2 líneas en lugar de 4) */\r\n.respuesta-contenido .comentario-texto.plegado {\r\n  display: -webkit-box;\r\n  -webkit-box-orient: vertical;\r\n  overflow: hidden;\r\n  mask-image: linear-gradient(to bottom, #000 60%, transparent 100%);\r\n  -webkit-mask-image: linear-gradient(to bottom, #000 60%, transparent 100%);\r\n}\r\n\r\n/* Botón \"Ver más\" en respuestas (más pequeño) */\r\n.respuesta-contenido .btn-ver-mas {\r\n  font-size: 0.75rem;\r\n  padding: 2px 0;\r\n  margin-top: 2px;\r\n}\r\n\r\n.respuesta-contenido .btn-ver-mas i {\r\n  font-size: 0.65rem;\r\n}\r\n\r\n/* ============================================\r\n   DROPDOWN DE USUARIO - ESCRITORIO\r\n   ============================================ */\r\n\r\n@media (min-width: 992px) {\r\n  .user-dropdown {\r\n    background-color: #ffffff;\r\n    border: 2px solid #db1010;\r\n    border-radius: 10px;\r\n    box-shadow: 0 8px 24px rgba(0,0,0,0.2);\r\n    min-width: 240px;\r\n    padding: 8px 0;\r\n    margin-top: 8px;\r\n  }\r\n\r\n  .user-dropdown .dropdown-header {\r\n    color: #db1010;\r\n    font-weight: 700;\r\n    font-size: 0.75rem;\r\n    text-transform: uppercase;\r\n    letter-spacing: 1px;\r\n    padding: 10px 18px 6px;\r\n    border-bottom: 1px solid #e9ecef;\r\n    margin-bottom: 4px;\r\n  }\r\n\r\n  .user-dropdown .dropdown-item {\r\n    color: #333;\r\n    font-size: 0.9rem;\r\n    font-weight: 500;\r\n    padding: 10px 18px;\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 8px;\r\n  }\r\n\r\n  .user-dropdown .dropdown-item:hover {\r\n    background-color: #f8f9fa;\r\n    color: #db1010;\r\n  }\r\n\r\n  .user-dropdown .dropdown-item.active {\r\n    background-color: #db1010;\r\n    color: white;\r\n  }\r\n\r\n  .user-dropdown .dropdown-item i {\r\n    width: 20px;\r\n    text-align: center;\r\n  }\r\n\r\n  .user-dropdown .dropdown-item-text {\r\n    padding: 10px 18px;\r\n    font-size: 0.9rem;\r\n    color: #6c757d;\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 8px;\r\n  }\r\n\r\n  .user-dropdown .dropdown-item.text-danger {\r\n    color: #dc3545;\r\n    font-weight: 600;\r\n  }\r\n\r\n  .user-dropdown .dropdown-item.text-danger:hover {\r\n    background-color: #dc3545;\r\n    color: white;\r\n  }\r\n\r\n  .user-dropdown .dropdown-divider {\r\n    margin: 6px 0;\r\n    border-color: #e9ecef;\r\n  }\r\n}\r\n\r\n/* ============================================\r\n   DROPDOWN DE USUARIO - MÓVIL Y TABLET\r\n   ============================================ */\r\n\r\n@media (max-width: 991.98px) {\r\n  .user-dropdown {\r\n    position: static !important;\r\n    background-color: rgba(0, 0, 0, 0.3) !important;\r\n    border: none !important;\r\n    border-radius: 8px !important;\r\n    box-shadow: none !important;\r\n    margin-top: 8px !important;\r\n    padding: 0 !important;\r\n    width: 100% !important;\r\n  }\r\n\r\n  .user-dropdown .dropdown-header {\r\n    color: #ffffff !important;\r\n    background-color: rgba(0, 0, 0, 0.2) !important;\r\n    font-weight: 700 !important;\r\n    font-size: 0.75rem !important;\r\n    text-transform: uppercase !important;\r\n    letter-spacing: 1px !important;\r\n    padding: 10px 16px !important;\r\n    margin: 0 !important;\r\n    border: none !important;\r\n    border-bottom: 1px solid rgba(255, 255, 255, 0.15) !important;\r\n  }\r\n\r\n  .user-dropdown .dropdown-item {\r\n    color: #ffffff !important;\r\n    background-color: transparent !important;\r\n    font-size: 0.95rem !important;\r\n    font-weight: 500 !important;\r\n    padding: 12px 16px !important;\r\n    border: none !important;\r\n    border-bottom: 1px solid rgba(255, 255, 255, 0.1) !important;\r\n    border-radius: 0 !important;\r\n    display: flex !important;\r\n    align-items: center !important;\r\n    gap: 10px !important;\r\n    width: 100% !important;\r\n    text-align: left !important;\r\n  }\r\n\r\n  .user-dropdown .dropdown-item:last-child {\r\n    border-bottom: none !important;\r\n  }\r\n\r\n  .user-dropdown .dropdown-item:hover,\r\n  .user-dropdown .dropdown-item:focus {\r\n    background-color: rgba(255, 255, 255, 0.15) !important;\r\n    color: #ffffff !important;\r\n  }\r\n\r\n  .user-dropdown .dropdown-item.active {\r\n    background-color: rgba(255, 255, 255, 0.2) !important;\r\n    color: #ffffff !important;\r\n    border-left: 4px solid #ffd700 !important;\r\n    padding-left: 12px !important;\r\n  }\r\n\r\n  .user-dropdown .dropdown-item i {\r\n    color: #ffffff !important;\r\n    width: 20px !important;\r\n    text-align: center !important;\r\n    font-size: 1rem !important;\r\n  }\r\n\r\n  .user-dropdown .dropdown-item-text {\r\n    color: #ffffff !important;\r\n    background-color: transparent !important;\r\n    padding: 12px 16px !important;\r\n    border-bottom: 1px solid rgba(255, 255, 255, 0.1) !important;\r\n    display: flex !important;\r\n    align-items: center !important;\r\n    gap: 10px !important;\r\n    font-size: 0.95rem !important;\r\n  }\r\n\r\n  .user-dropdown .dropdown-item-text i {\r\n    color: #ffffff !important;\r\n    width: 20px !important;\r\n    text-align: center !important;\r\n  }\r\n\r\n  .user-dropdown .dropdown-item.text-danger {\r\n    color: #ffcccc !important;\r\n    font-weight: 600 !important;\r\n    border-bottom: none !important;\r\n  }\r\n\r\n  .user-dropdown .dropdown-item.text-danger:hover {\r\n    background-color: rgba(220, 53, 69, 0.5) !important;\r\n    color: #ffffff !important;\r\n  }\r\n\r\n  .user-dropdown .dropdown-divider {\r\n    margin: 0 !important;\r\n    border-color: rgba(255, 255, 255, 0.15) !important;\r\n  }\r\n\r\n  /* Botón del dropdown en móvil */\r\n  .navbar .dropdown-toggle {\r\n    color: #ffffff !important;\r\n    background-color: transparent !important;\r\n    border: none !important;\r\n    width: 100% !important;\r\n    text-align: left !important;\r\n    padding: 10px 0 !important;\r\n    font-size: 1rem !important;\r\n  }\r\n\r\n  .navbar .dropdown-toggle:hover,\r\n  .navbar .dropdown-toggle:focus {\r\n    color: #ffd700 !important;\r\n  }\r\n\r\n  .navbar .dropdown-toggle::after {\r\n    float: right;\r\n    margin-top: 8px;\r\n    color: #ffffff !important;\r\n  }\r\n}\r\n\r\n/* ============================================\r\n   RESPONSIVE - PANTALLAS MUY PEQUEÑAS\r\n   ============================================ */\r\n\r\n@media (max-width: 575.98px) {\r\n  .user-dropdown .dropdown-item {\r\n    padding: 10px 14px !important;\r\n    font-size: 0.9rem !important;\r\n  }\r\n\r\n  .user-dropdown .dropdown-header {\r\n    font-size: 0.7rem !important;\r\n    padding: 8px 14px !important;\r\n  }\r\n\r\n  .user-dropdown .dropdown-item-text {\r\n    padding: 10px 14px !important;\r\n    font-size: 0.9rem !important;\r\n  }\r\n}\r\n\r\n/* ============================================\r\n   CRONOGRAMA - ESTADÍSTICAS\r\n   ============================================ */\r\n\r\n.stat-card {\r\n  background: white;\r\n  border-radius: 12px;\r\n  padding: 16px;\r\n  text-align: center;\r\n  box-shadow: 0 2px 8px rgba(0,0,0,0.08);\r\n  border-left: 4px solid #db1010;\r\n  transition: transform 0.2s ease;\r\n}\r\n\r\n.stat-card:hover {\r\n  transform: translateY(-3px);\r\n  box-shadow: 0 6px 16px rgba(0,0,0,0.12);\r\n}\r\n\r\n.stat-card.stat-total { border-left-color: #db1010; }\r\n.stat-card.stat-presencial { border-left-color: #28a745; }\r\n.stat-card.stat-virtual { border-left-color: #17a2b8; }\r\n\r\n.stat-number {\r\n  font-size: 2rem;\r\n  font-weight: 700;\r\n  color: #333;\r\n  line-height: 1;\r\n}\r\n\r\n.stat-label {\r\n  font-size: 0.8rem;\r\n  color: #6c757d;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.5px;\r\n  margin-top: 4px;\r\n}\r\n\r\n/* ============================================\r\n   CALENDARIO COMPACTO\r\n   ============================================ */\r\n\r\n.calendar-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(7, 1fr);\r\n  gap: 2px;\r\n  max-width: 100%;\r\n}\r\n\r\n.calendar-header-cell {\r\n  text-align: center;\r\n  font-weight: 700;\r\n  font-size: 0.65rem;   /* ← más pequeño */\r\n  color: #6c757d;\r\n  text-transform: uppercase;\r\n  padding: 4px 2px;\r\n  background-color: #f8f9fa;\r\n  border-radius: 4px;\r\n  letter-spacing: 0.3px;\r\n}\r\n\r\n.calendar-cell {\r\n  aspect-ratio: 1;\r\n  background: white;\r\n  border: 1px solid #e9ecef;\r\n  border-radius: 4px;\r\n  padding: 2px 3px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  position: relative;\r\n  transition: all 0.15s ease;\r\n  min-height: 32px;   /* ← antes 60px */\r\n  max-height: 40px;\r\n  overflow: hidden;\r\n}\r\n\r\n.calendar-cell.empty {\r\n  background: transparent;\r\n  border: none;\r\n}\r\n\r\n.calendar-cell.has-event {\r\n  background: linear-gradient(135deg, #fff5f5 0%, #ffe5e5 100%);\r\n  border-color: #db1010;\r\n  cursor: pointer;\r\n}\r\n\r\n.calendar-cell.has-event:hover {\r\n  transform: scale(1.08);\r\n  box-shadow: 0 2px 8px rgba(219, 16, 16, 0.25);\r\n  z-index: 10;\r\n}\r\n\r\n.calendar-day {\r\n  font-weight: 700;\r\n  font-size: 0.7rem;   /* ← antes 0.9rem */\r\n  color: #333;\r\n  line-height: 1;\r\n}\r\n\r\n.calendar-events {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 2px;\r\n  margin-top: 2px;\r\n}\r\n\r\n.calendar-event-dot {\r\n  width: 5px;    /* ← antes 8px */\r\n  height: 5px;\r\n  border-radius: 50%;\r\n}\r\n\r\n.dot-presencial {\r\n  background-color: #db1010;   /* ← Rojo intenso */\r\n}\r\n\r\n.dot-virtual {\r\n  background-color: #0d47a1;   /* ← Azul profundo */\r\n}\r\n\r\n/* Badges de tipo */\r\n.badge.bg-success {\r\n  background-color: #db1010 !important;  /* Presencial = rojo */\r\n}\r\n\r\n.badge.bg-info {\r\n  background-color: #0d47a1 !important;  /* Virtual = azul */\r\n}\r\n\r\n.calendar-more {\r\n  font-size: 0.55rem;\r\n  color: #db1010;\r\n  font-weight: 700;\r\n}\r\n\r\n.legend-dot {\r\n  width: 10px;\r\n  height: 10px;\r\n  border-radius: 50%;\r\n}\r\n\r\n/* ============================================\r\n   TARJETAS DE SESIÓN\r\n   ============================================ */\r\n\r\n.sesion-card {\r\n  background: white;\r\n  border-radius: 12px;\r\n  overflow: hidden;\r\n  box-shadow: 0 2px 8px rgba(0,0,0,0.08);\r\n  transition: all 0.3s ease;\r\n  border-left: 4px solid #db1010;\r\n  height: 100%;\r\n}\r\n\r\n.sesion-card.card-presencial {\r\n  border-left-color: #db1010;\r\n}\r\n\r\n.sesion-card.card-virtual {\r\n  border-left-color: #0d47a1;\r\n}\r\n\r\n.sesion-card:hover {\r\n  transform: translateY(-3px);\r\n  box-shadow: 0 8px 20px rgba(0,0,0,0.12);\r\n}\r\n\r\n.sesion-card-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 12px 16px;\r\n  background-color: #f8f9fa;\r\n  border-bottom: 1px solid #e9ecef;\r\n}\r\n\r\n.sesion-card-fecha {\r\n  font-weight: 700;\r\n  color: #333;\r\n  font-size: 0.9rem;\r\n}\r\n\r\n.sesion-card-body {\r\n  padding: 16px;\r\n}\r\n\r\n.sesion-modulo {\r\n  color: #db1010;\r\n  font-weight: 700;\r\n}\r\n\r\n.sesion-num {\r\n  color: #6c757d;\r\n  font-size: 0.9rem;\r\n}\r\n\r\n.sesion-info {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 4px;\r\n  font-size: 0.85rem;\r\n  color: #6c757d;\r\n  margin-top: 8px;\r\n}\r\n\r\n/* ============================================\r\n   VISTA LINEAL (TIMELINE)\r\n   ============================================ */\r\n\r\n.modulo-group {\r\n  background: white;\r\n  border-radius: 12px;\r\n  padding: 20px;\r\n  box-shadow: 0 2px 8px rgba(0,0,0,0.08);\r\n}\r\n\r\n.modulo-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding-bottom: 12px;\r\n  margin-bottom: 16px;\r\n  border-bottom: 2px solid #db1010;\r\n  color: #db1010;\r\n}\r\n\r\n.modulo-timeline {\r\n  position: relative;\r\n  padding-left: 24px;\r\n}\r\n\r\n.modulo-timeline::before {\r\n  content: '';\r\n  position: absolute;\r\n  left: 8px;\r\n  top: 0;\r\n  bottom: 0;\r\n  width: 2px;\r\n  background: linear-gradient(to bottom, #db1010 0%, #e9ecef 100%);\r\n}\r\n\r\n.timeline-item {\r\n  position: relative;\r\n  margin-bottom: 20px;\r\n  padding-left: 24px;\r\n}\r\n\r\n.timeline-item:last-child {\r\n  margin-bottom: 0;\r\n}\r\n\r\n.timeline-dot {\r\n  position: absolute;\r\n  left: -20px;\r\n  top: 6px;\r\n  width: 14px;\r\n  height: 14px;\r\n  border-radius: 50%;\r\n  border: 3px solid white;\r\n  box-shadow: 0 0 0 2px #e9ecef;\r\n}\r\n\r\n/* Timeline dots */\r\n.timeline-dot.dot-presencial {\r\n  background-color: #db1010;\r\n  box-shadow: 0 0 0 2px #db1010;\r\n}\r\n\r\n.timeline-dot.dot-virtual {\r\n  background-color: #0d47a1;\r\n  box-shadow: 0 0 0 2px #0d47a1;\r\n}\r\n\r\n.timeline-content {\r\n  background: #f8f9fa;\r\n  border-radius: 8px;\r\n  padding: 12px 16px;\r\n  transition: all 0.2s ease;\r\n}\r\n\r\n.timeline-content:hover {\r\n  background: #e9ecef;\r\n  transform: translateX(4px);\r\n}\r\n\r\n.timeline-sesion {\r\n  color: #db1010;\r\n  font-size: 1rem;\r\n}\r\n\r\n.timeline-details {\r\n  font-size: 0.85rem;\r\n  color: #6c757d;\r\n  margin-top: 4px;\r\n}\r\n\r\n/* ============================================\r\n   MODAL DE SESIÓN\r\n   ============================================ */\r\n\r\n.modal-backdrop-custom {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background-color: rgba(0,0,0,0.5);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  z-index: 9999;\r\n  padding: 20px;\r\n  animation: fadeIn 0.2s ease;\r\n}\r\n\r\n@keyframes fadeIn {\r\n  from { opacity: 0; }\r\n  to { opacity: 1; }\r\n}\r\n\r\n.modal-card {\r\n  background: white;\r\n  border-radius: 12px;\r\n  max-width: 380px;\r\n  width: 100%;\r\n  box-shadow: 0 20px 60px rgba(0,0,0,0.3);\r\n  animation: slideUp 0.3s ease;\r\n  overflow: hidden;\r\n}\r\n\r\n@keyframes slideUp {\r\n  from { opacity: 0; transform: translateY(20px); }\r\n  to { opacity: 1; transform: translateY(0); }\r\n}\r\n\r\n.modal-card-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 12px 16px;\r\n  background-color: #db1010;\r\n  color: white;\r\n}\r\n\r\n.btn-close-custom {\r\n  background: none;\r\n  border: none;\r\n  color: white;\r\n  font-size: 1.2rem;\r\n  cursor: pointer;\r\n  padding: 4px 8px;\r\n  border-radius: 6px;\r\n  transition: background 0.2s;\r\n}\r\n\r\n.btn-close-custom:hover {\r\n  background-color: rgba(255,255,255,0.2);\r\n}\r\n\r\n.modal-card-body {\r\n  padding: 16px;\r\n}\r\n\r\n.sesion-detalle {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 12px;\r\n  margin-top: 16px;\r\n  font-size: 0.95rem;\r\n}\r\n\r\n/* ============================================\r\n   RESPONSIVE - CALENDARIO\r\n   ============================================ */\r\n\r\n/* Escritorio grande: Calendario más ancho pero aún compacto */\r\n@media (min-width: 992px) {\r\n  .calendar-grid {\r\n    gap: 3px;\r\n  }\r\n\r\n  .calendar-cell {\r\n    min-height: 38px;\r\n    max-height: 46px;\r\n  }\r\n\r\n  .calendar-day {\r\n    font-size: 0.75rem;\r\n  }\r\n}\r\n\r\n/* Tablet: Ajustar proporciones */\r\n@media (max-width: 991.98px) and (min-width: 577px) {\r\n  .calendar-grid {\r\n    gap: 2px;\r\n  }\r\n\r\n  .calendar-cell {\r\n    min-height: 34px;\r\n    max-height: 42px;\r\n    padding: 2px;\r\n  }\r\n\r\n  .calendar-day {\r\n    font-size: 0.7rem;\r\n  }\r\n}\r\n\r\n/* Móvil: Compacto */\r\n@media (max-width: 576px) {\r\n  .calendar-grid {\r\n    gap: 2px;\r\n  }\r\n\r\n  .calendar-cell {\r\n    min-height: 30px;\r\n    max-height: 36px;\r\n    padding: 2px;\r\n    border-radius: 3px;\r\n  }\r\n\r\n  .calendar-day {\r\n    font-size: 0.65rem;\r\n  }\r\n\r\n  .calendar-header-cell {\r\n    font-size: 0.55rem;\r\n    padding: 3px 1px;\r\n  }\r\n\r\n  .calendar-event-dot {\r\n    width: 4px;\r\n    height: 4px;\r\n  }\r\n\r\n  .calendar-more {\r\n    font-size: 0.5rem;\r\n  }\r\n\r\n  .modal-card {\r\n    max-width: 95%;\r\n  }\r\n\r\n  .modal-card-header,\r\n  .modal-card-body {\r\n    padding: 12px;\r\n  }\r\n}\r\n\r\n/* Móvil muy pequeño */\r\n@media (max-width: 400px) {\r\n  .calendar-cell {\r\n    min-height: 26px;\r\n    max-height: 32px;\r\n    padding: 1px;\r\n  }\r\n\r\n  .calendar-day {\r\n    font-size: 0.6rem;\r\n  }\r\n\r\n  .calendar-header-cell {\r\n    font-size: 0.5rem;\r\n  }\r\n}\r\n\r\n/* ============================================\r\n   BANNER CON CARRUSEL - SIN ESPACIO SUPERIOR\r\n   ============================================ */\r\n\r\n.banner-foro {\r\n  width: 100%;\r\n  margin: 0;\r\n  padding: 0;\r\n  background-color: #db1010;\r\n  margin-top: 0;        /* ← SIN margen superior */\r\n  overflow: hidden;\r\n  line-height: 0;\r\n  display: block;\r\n}\r\n\r\n.banner-carousel {\r\n  position: relative;\r\n  width: 100%;\r\n  overflow: hidden;\r\n  display: block;\r\n  line-height: 0;\r\n}\r\n\r\n.banner-slide {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: auto;\r\n  max-height: 380px;\r\n  object-fit: cover;\r\n  opacity: 0;\r\n  transition: opacity 1.5s ease-in-out;\r\n  display: block;\r\n}\r\n\r\n.banner-slide.active {\r\n  opacity: 1;\r\n  position: relative;   /* ← Define la altura según la imagen */\r\n}\r\n\r\n/* Responsive */\r\n@media (max-width: 768px) {\r\n  .banner-slide {\r\n    max-height: 150px;\r\n  }\r\n}\r\n\r\n@media (max-width: 576px) {\r\n  .banner-slide {\r\n    max-height: 100px;\r\n  }\r\n}\r\n\r\n/* ============================================\r\n   RETROALIMENTACIONES\r\n   ============================================ */\r\n\r\n.retroalimentacion-section {\r\n  border-top: 1px solid #e9ecef;\r\n  padding-top: 12px;\r\n  margin-top: 12px;\r\n}\r\n\r\n.retroalimentacion-card {\r\n  background: #f8f9fa;\r\n  border-left: 3px solid #db1010;\r\n  border-radius: 8px;\r\n  padding: 12px 16px;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.retroalimentacion-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin-bottom: 6px;\r\n}\r\n\r\n.retroalimentacion-usuario {\r\n  color: #db1010;\r\n  font-size: 0.9rem;\r\n}\r\n\r\n.retroalimentacion-contenido {\r\n  margin: 6px 0;\r\n  font-size: 0.9rem;\r\n  line-height: 1.5;\r\n}\r\n\r\n.retroalimentacion-contenido .comentario-texto.plegado {\r\n  max-height: 6em;   /* 4 líneas × 1.5em line-height */\r\n  overflow: hidden;\r\n  position: relative;\r\n}\r\n\r\n.retroalimentacion-contenido .comentario-texto.plegado::after {\r\n  content: '';\r\n  position: absolute;\r\n  bottom: 0;\r\n  left: 0;\r\n  right: 0;\r\n  height: 2em;\r\n  background: linear-gradient(to bottom, transparent, #f8f9fa);\r\n  pointer-events: none;\r\n}\r\n\r\n.retroalimentacion-archivo {\r\n  border-top: 1px dashed #dee2e6;\r\n  padding-top: 8px;\r\n  margin-top: 8px;\r\n}\r\n\r\n/* ============================================\r\n   MODAL GENÉRICO (usado por ambos modales)\r\n   ============================================ */\r\n\r\n.modal-backdrop-custom {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background-color: rgba(0, 0, 0, 0.6);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  z-index: 99999;\r\n  padding: 20px;\r\n  animation: fadeIn 0.2s ease;\r\n}\r\n\r\n@keyframes fadeIn {\r\n  from { opacity: 0; }\r\n  to { opacity: 1; }\r\n}\r\n\r\n.modal-card {\r\n  background: white;\r\n  border-radius: 12px;\r\n  max-width: 450px;\r\n  width: 100%;\r\n  max-height: 90vh;\r\n  overflow-y: auto;\r\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.4);\r\n  animation: slideUp 0.3s ease;\r\n  position: relative;\r\n  z-index: 100000;\r\n}\r\n\r\n@keyframes slideUp {\r\n  from { \r\n    opacity: 0; \r\n    transform: translateY(20px); \r\n  }\r\n  to { \r\n    opacity: 1; \r\n    transform: translateY(0); \r\n  }\r\n}\r\n\r\n.modal-card-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 16px 20px;\r\n  background-color: #db1010;\r\n  color: white;\r\n  border-radius: 12px 12px 0 0;\r\n}\r\n\r\n.modal-card-header h5 {\r\n  color: white;\r\n  margin: 0;\r\n  font-weight: 600;\r\n}\r\n\r\n.btn-close-custom {\r\n  background: none;\r\n  border: none;\r\n  color: white;\r\n  font-size: 1.1rem;\r\n  cursor: pointer;\r\n  padding: 4px 8px;\r\n  border-radius: 6px;\r\n  transition: background 0.2s;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.btn-close-custom:hover {\r\n  background-color: rgba(255, 255, 255, 0.2);\r\n}\r\n\r\n.modal-card-body {\r\n  padding: 24px;\r\n}\r\n\r\n/* ============================================\r\n   CAMPOS DE FORMULARIO DENTRO DEL MODAL\r\n   ============================================ */\r\n\r\n.modal-card-body .form-label {\r\n  color: #333;\r\n  font-weight: 600;\r\n  font-size: 0.85rem;\r\n  margin-bottom: 6px;\r\n}\r\n\r\n.modal-card-body .form-control {\r\n  border-radius: 8px;\r\n  border: 1px solid #dee2e6;\r\n  padding: 10px 14px;\r\n  transition: border-color 0.2s, box-shadow 0.2s;\r\n  font-size: 0.95rem;\r\n}\r\n\r\n.modal-card-body .form-control:focus {\r\n  border-color: #db1010;\r\n  box-shadow: 0 0 0 0.2rem rgba(219, 16, 16, 0.15);\r\n  outline: none;\r\n}\r\n\r\n/* ============================================\r\n   ENLACE \"¿OLVIDASTE TU CONTRASEÑA?\" EN LOGIN\r\n   ============================================ */\r\n\r\n.login-card .btn-link {\r\n  color: #6c757d !important;\r\n  text-decoration: underline !important;\r\n  font-size: 0.85rem;\r\n  border: none;\r\n  background: none;\r\n  cursor: pointer;\r\n  padding: 0;\r\n}\r\n\r\n.login-card .btn-link:hover {\r\n  color: #db1010 !important;\r\n}\r\n\r\n/* ============================================\r\n   INPUT DE CONTRASEÑA CON OJO\r\n   ============================================ */\r\n\r\n.password-input-wrapper {\r\n  position: relative;\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.password-input-wrapper .password-input {\r\n  padding-right: 45px;  /* Espacio para el ícono */\r\n}\r\n\r\n.password-toggle {\r\n  position: absolute;\r\n  right: 8px;\r\n  top: 50%;\r\n  transform: translateY(-50%);\r\n  background: none;\r\n  border: none;\r\n  color: #6c757d;\r\n  font-size: 1.1rem;\r\n  padding: 6px 10px;\r\n  cursor: pointer;\r\n  border-radius: 6px;\r\n  transition: color 0.2s, background-color 0.2s;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  line-height: 1;\r\n}\r\n\r\n.password-toggle:hover {\r\n  color: #db1010;\r\n  background-color: rgba(219, 16, 16, 0.08);\r\n}\r\n\r\n.password-toggle:focus {\r\n  outline: none;\r\n  color: #db1010;\r\n}\r\n\r\n.password-toggle i {\r\n  pointer-events: none;  /* El ícono no interfiere con el clic */\r\n}\r\n\r\n/* linkify*/\r\n\r\n.comentario-texto a {\r\n  color: #db1010;\r\n  text-decoration: underline;\r\n  word-break: break-word;\r\n}\r\n\r\n.comentario-texto a:hover {\r\n  color: #600000;\r\n  text-decoration: none;\r\n}\r\n\r\n/* ============================================\r\n   PRÓXIMA SESIÓN - PANEL DESTACADO\r\n   ============================================ */\r\n\r\n.proxima-sesion-panel {\r\n  margin-top: 0;\r\n}\r\n\r\n.proxima-sesion-card {\r\n  position: relative;\r\n  background: linear-gradient(135deg, #db1010 0%, #600000 100%);\r\n  border-radius: 20px;\r\n  padding: 2rem;\r\n  color: white;\r\n  box-shadow: 0 12px 40px rgba(219, 16, 16, 0.4);\r\n  overflow: hidden;\r\n  animation: proximaPulse 3s ease-in-out infinite;\r\n}\r\n\r\n@keyframes proximaPulse {\r\n  0%, 100% { box-shadow: 0 12px 40px rgba(219, 16, 16, 0.4); }\r\n  50% { box-shadow: 0 12px 60px rgba(219, 16, 16, 0.7); }\r\n}\r\n\r\n.proxima-sesion-card::before {\r\n  content: '';\r\n  position: absolute;\r\n  top: -50%;\r\n  left: -50%;\r\n  width: 200%;\r\n  height: 200%;\r\n  background: linear-gradient(\r\n    45deg,\r\n    transparent 30%,\r\n    rgba(255, 255, 255, 0.1) 50%,\r\n    transparent 70%\r\n  );\r\n  animation: shine 4s ease-in-out infinite;\r\n}\r\n\r\n@keyframes shine {\r\n  0% { transform: translateX(-100%) translateY(-100%) rotate(45deg); }\r\n  100% { transform: translateX(100%) translateY(100%) rotate(45deg); }\r\n}\r\n\r\n.proxima-sesion-badge {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 0.5rem;\r\n  background: rgba(255, 255, 255, 0.2);\r\n  color: white;\r\n  padding: 0.4rem 1rem;\r\n  border-radius: 20px;\r\n  font-size: 0.75rem;\r\n  font-weight: 700;\r\n  letter-spacing: 1.5px;\r\n  text-transform: uppercase;\r\n  margin-bottom: 1.5rem;\r\n  backdrop-filter: blur(10px);\r\n  border: 1px solid rgba(255, 255, 255, 0.3);\r\n  position: relative;\r\n  z-index: 1;\r\n}\r\n\r\n.proxima-sesion-badge i {\r\n  animation: blink 1.5s ease-in-out infinite;\r\n}\r\n\r\n@keyframes blink {\r\n  0%, 100% { opacity: 1; }\r\n  50% { opacity: 0.4; }\r\n}\r\n\r\n.proxima-sesion-content {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  gap: 1.5rem;\r\n  position: relative;\r\n  z-index: 1;\r\n}\r\n\r\n.proxima-sesion-icon {\r\n  flex-shrink: 0;\r\n  width: 70px;\r\n  height: 70px;\r\n  background: rgba(255, 255, 255, 0.15);\r\n  border-radius: 50%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-size: 2rem;\r\n  backdrop-filter: blur(10px);\r\n  border: 2px solid rgba(255, 255, 255, 0.3);\r\n}\r\n\r\n.proxima-sesion-info {\r\n  flex-grow: 1;\r\n}\r\n\r\n.proxima-sesion-title {\r\n  font-family: 'Roboto Slab', serif;\r\n  font-weight: 700;\r\n  font-size: 1.6rem;\r\n  margin-bottom: 0.5rem;\r\n  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);\r\n}\r\n\r\n.proxima-sesion-desc {\r\n  font-size: 1rem;\r\n  opacity: 0.95;\r\n  margin-bottom: 1.25rem;\r\n  line-height: 1.5;\r\n}\r\n\r\n.proxima-sesion-btn {\r\n  background: white;\r\n  color: #db1010;\r\n  font-weight: 700;\r\n  padding: 0.75rem 1.75rem;\r\n  border-radius: 12px;\r\n  border: none;\r\n  transition: all 0.3s ease;\r\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);\r\n}\r\n\r\n.proxima-sesion-btn:hover {\r\n  background: white;\r\n  color: #600000;\r\n  transform: translateY(-2px) scale(1.02);\r\n  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.3);\r\n}\r\n\r\n.proxima-sesion-empty {\r\n  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);\r\n  border: 2px dashed #adb5bd;\r\n  border-radius: 20px;\r\n  padding: 2.5rem;\r\n  text-align: center;\r\n  color: #6c757d;\r\n}\r\n\r\n.proxima-sesion-empty i {\r\n  font-size: 3rem;\r\n  color: #adb5bd;\r\n  margin-bottom: 1rem;\r\n  display: block;\r\n  animation: hourglass 3s ease-in-out infinite;\r\n}\r\n\r\n@keyframes hourglass {\r\n  0%, 100% { transform: rotate(0deg); }\r\n  50% { transform: rotate(180deg); }\r\n}\r\n\r\n.proxima-sesion-empty p {\r\n  font-size: 1.1rem;\r\n  font-weight: 500;\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .proxima-sesion-card { padding: 1.5rem; }\r\n  .proxima-sesion-content { flex-direction: column; align-items: center; text-align: center; }\r\n  .proxima-sesion-icon { width: 60px; height: 60px; font-size: 1.6rem; }\r\n  .proxima-sesion-title { font-size: 1.3rem; }\r\n  .proxima-sesion-btn { width: 100%; }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
